import styled from 'styled-components';

export const ColLabel = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  vertical-align: middle;
  padding-top: 0.6rem;
`;
